import React from "react";
import { GridContainer, SelectionSet, Row, SelectionSetInput, SelectionSetLabel, Span, Column, Box, Callout, FlexBox, useId, Typography, } from "@vp/swan";
import { useProductOptionsTranslations } from "../../product-options-translations/product-option-translations";
export const ProductPageButton = (props) => {
    const { option, onChanged, showIncompatibleChoices } = props;
    const { i18n } = useProductOptionsTranslations();
    const onChangeHandler = (choiceKey) => {
        if (onChanged) {
            onChanged({ choiceKey, isValid: true });
        }
    };
    const totalButtons = option.choices.filter((choice) => showIncompatibleChoices || choice.isCompatible).length;
    const buttonSpan = totalButtons === 1 ? 12 : 6;
    const calloutTextMap = {
        legacy_recommended: "recommendedCallout",
        legacy_new: "newCallout",
        legacy_incompatible: "incompatibleLabel",
        legacy_outofstock: "outOfStockCallout",
    };
    const calloutSkinMap = {
        legacy_recommended: "accent",
        legacy_new: "accent",
        legacy_incompatible: "info",
        legacy_outofstock: "info",
    };
    const titleId = useId();
    // Compatible choices are always shown.
    // Out of stock choices are always shown,
    // Incompatible choices are shown based on the flag - showIncompatibleChoices.
    const choices = option.choices.filter((choice) => choice.isCompatible || choice.isOutOfStock || showIncompatibleChoices);
    return (React.createElement(Box, { role: "group", "aria-labelledby": titleId, className: "product-page-button-container" },
        React.createElement(Box, { mb: 2 },
            React.createElement(Typography, { as: "label", fontSkin: "body-standard-bold", id: titleId }, option.name)),
        React.createElement(SelectionSet, { variant: "single-select", skin: "buttons", selectedValue: option.selectedKey, onSelectedValueChange: onChangeHandler, className: "product-page-button-selection-set" },
            React.createElement(GridContainer, null,
                React.createElement(Row, null, choices.map((choice, index) => {
                    /* Assuming the first callout is highest priority */
                    const firstCallout = choice.callouts?.[0];
                    const localizedText = (firstCallout && i18n(calloutTextMap[firstCallout.text])) ?? "";
                    const calloutSkin = (firstCallout && calloutSkinMap[firstCallout.text]) ?? "accent";
                    const buttonPadding = {
                        paddingLeft: index % 2 === 1 ? "6px" : undefined,
                        paddingRight: index % 2 === 0 ? "6px" : undefined,
                    };
                    return (React.createElement(Column, { span: buttonSpan, key: choice.key, spanXs: buttonSpan, style: totalButtons === 1 ? undefined : buttonPadding },
                        React.createElement(SelectionSetInput, { key: choice.key, value: choice.key, disabled: choice.isOutOfStock },
                            React.createElement(SelectionSetLabel, { style: { width: "100%", minWidth: "auto" } },
                                React.createElement(FlexBox, { alignItems: "center", justifyContent: "center", flexDirection: "column" },
                                    React.createElement(Span, { fontSize: "small", fontWeight: "bold" }, choice.name),
                                    firstCallout && localizedText && (React.createElement(Callout, { skin: calloutSkin, emphasis: "low" }, localizedText)))))));
                }))))));
};
//# sourceMappingURL=product-page-button.js.map